'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var gql = _interopDefault(require('graphql-tag'));

var _templateObject;
var graphql = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Maptiler {\n    maptiler {\n      key\n    }\n  }\n"])));

exports.default = graphql;
